/* Product assistant panel (snippets/pdp-assistant.liquid + snippets/pdp-documentation-tab.liquid).
   Figma "Product Document Assistant": drawer 2726:137, mobile sheet 2733:318, states 2733:183,
   response types 2746:183, conversation & input states 2747:183.

   - Opens from the Documentation & assistant card (question box, chips) or any [data-pa-open].
   - role="dialog" + aria-modal with a focus trap; Esc closes; focus returns to the launcher.
   - The conversation is kept per product in sessionStorage and sent with each question, so the
     API stays stateless.
   - Every answer is rendered from structured JSON (answer_type, source, facts, steps, table,
     citations, followups); nothing from the model is inserted as HTML. */
(function () {
  'use strict';

  var configEl = document.querySelector('[data-pa-config]');
  var root = document.querySelector('[data-pa-root]');
  if (!configEl || !root) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg.api) return;

  var API = cfg.api.replace(/\/+$/, '');
  var T = cfg.i18n || {};
  var ICON = cfg.icons || {};
  var MAX_CHARS = 500;
  var COUNTER_FROM = 400;
  var SLOW_AFTER_MS = 8000;
  var TIMEOUT_MS = 30000;
  var HISTORY_TURNS = 10;
  var STORE_KEY = 'pa:' + (cfg.partNumber || location.pathname);

  var panel = root.querySelector('[data-pa-panel]');
  var log = root.querySelector('[data-pa-log]');
  var form = root.querySelector('[data-pa-form]');
  var textarea = root.querySelector('[data-pa-textarea]');
  var sendBtn = root.querySelector('[data-pa-send]');
  var inputBox = root.querySelector('[data-pa-input]');
  var helper = root.querySelector('[data-pa-helper]');
  var helperText = root.querySelector('[data-pa-helper-text]');
  var counter = root.querySelector('[data-pa-counter]');
  var countdownEl = root.querySelector('[data-pa-countdown]');
  var menuBtn = root.querySelector('[data-pa-menu-button]');
  var menu = root.querySelector('[data-pa-menu]');
  var stopBtn = root.querySelector('[data-pa-stop]');
  var docPages = {};           // document url -> page count, from /api/documents

  var state = {
    turns: load(),          // [{role: 'user'|'assistant', text, data?, at}]
    restoredCount: 0,
    busy: false,
    controller: null,
    lastQuestion: '',
    rateUntil: 0,
    launcher: null
  };
  state.restoredCount = state.turns.length;

  // ------------------------------------------------------------------ helpers

  function t(key, vars) {
    var s = T[key] || '';
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('%{' + k + '}').join(vars[k]);
      });
    }
    return s;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function icon(name, size) {
    var img = el('img');
    img.src = ICON[name] || '';
    img.width = size;
    img.height = size;
    img.alt = '';
    return img;
  }

  function button(label, cls, onClick, iconName, iconSize) {
    var b = el('button', cls);
    b.type = 'button';
    if (iconName) b.appendChild(icon(iconName, iconSize || 14));
    b.appendChild(el('span', null, label));
    b.addEventListener('click', onClick);
    return b;
  }

  function load() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function save() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(state.turns.slice(-40)));
    } catch (e) { /* storage full or blocked: the conversation still works in memory */ }
  }

  function scrollToEnd() {
    log.scrollTop = log.scrollHeight;
  }

  function mailto(subjectKey, question) {
    var product = cfg.productTitle;
    var body = t('email_body_intro', { product: product, url: cfg.productUrl, question: question || '' });
    var transcript = transcriptText();
    if (transcript) body += '\n\n---\n' + transcript;
    // Mail clients truncate very long mailto URLs; keep the most recent part of the transcript
    if (body.length > 1800) body = body.slice(0, 1800) + '…';
    return 'mailto:' + (cfg.contactEmail || '') +
      '?subject=' + encodeURIComponent(t(subjectKey, { product: product })) +
      '&body=' + encodeURIComponent(body);
  }

  function openMail(subjectKey, question) {
    window.location.href = mailto(subjectKey, question);
  }

  // ------------------------------------------------------------------ open / close

  function open(launcher, question) {
    state.launcher = launcher || document.activeElement;
    if (root.hidden) {
      root.hidden = false;
      root.classList.remove('is-closing');
      document.documentElement.classList.add('pa-locked');
      // Keep whatever is in the log (an answer may still be streaming); only build it the first time
      if (!log.childElementCount) render();
      setViewportHeight();
    }
    requestSuggestions();
    if (question) {
      // Focus the dialog itself so mobile keyboards don't cover the answer that's loading
      panel.focus({ preventScroll: true });
      textarea.value = question;
      ask(question);
    } else {
      textarea.focus();
    }
    updateComposer();
  }

  function close() {
    if (root.hidden || root.classList.contains('is-closing')) return;
    closeMenu();
    root.classList.add('is-closing');
    var done = function () {
      root.hidden = true;
      root.classList.remove('is-closing');
      document.documentElement.classList.remove('pa-locked');
      if (state.launcher && state.launcher.focus) state.launcher.focus();
    };
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(done, reduced ? 0 : 190);
  }

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), textarea, input, [tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null && !n.closest('[hidden]'); }
    );
  }

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openPreview = root.querySelector('.pa-preview');
      if (openPreview && openPreview.paClose) {
        openPreview.paClose();
        e.preventDefault();
        return;
      }
      if (!menu.hidden) {
        closeMenu();
        menuBtn.focus();
      } else {
        close();
      }
      e.preventDefault();
      return;
    }
    if (e.key === 'Tab') {
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }
  });

  root.querySelectorAll('[data-pa-close]').forEach(function (n) {
    n.addEventListener('click', close);
  });

  // Mobile: keep the sheet above the on-screen keyboard
  function setViewportHeight() {
    var vv = window.visualViewport;
    root.style.setProperty('--pa-vh', (vv ? vv.height : window.innerHeight) + 'px');
  }
  if (window.visualViewport) window.visualViewport.addEventListener('resize', setViewportHeight);

  // ------------------------------------------------------------------ menu

  function openMenu() {
    menu.hidden = false;
    menuBtn.setAttribute('aria-expanded', 'true');
    var first = menu.querySelector('[role="menuitem"]');
    if (first) first.focus();
  }

  function closeMenu() {
    menu.hidden = true;
    menuBtn.setAttribute('aria-expanded', 'false');
  }

  menuBtn.addEventListener('click', function () {
    if (menu.hidden) openMenu(); else closeMenu();
  });

  menu.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var items = Array.prototype.slice.call(menu.querySelectorAll('[role="menuitem"]'));
    var i = items.indexOf(document.activeElement);
    var next = e.key === 'ArrowDown' ? (i + 1) % items.length : (i - 1 + items.length) % items.length;
    items[next].focus();
    e.preventDefault();
  });

  document.addEventListener('click', function (e) {
    if (!menu.hidden && !e.target.closest('.pa-menu-wrap')) closeMenu();
  });

  root.addEventListener('click', function (e) {
    var action = e.target.closest('[data-pa-action]');
    if (!action) return;
    var name = action.getAttribute('data-pa-action');
    if (name === 'new') newConversation();
    if (name === 'transcript') downloadTranscript();
    if (name === 'listing') showListing();
    if (name === 'report') reportProblem();
    closeMenu();
  });

  function newConversation() {
    if (state.controller) state.controller.abort();
    state.turns = [];
    state.restoredCount = 0;
    save();
    render();
    textarea.focus();
  }

  function transcriptText() {
    return state.turns.map(function (turn) {
      return (turn.role === 'user' ? t('you') : t('assistant')) + ': ' + turn.text;
    }).join('\n\n');
  }

  function downloadTranscript() {
    var text = t('transcript_title', { product: cfg.productTitle }) + '\n' + cfg.productUrl + '\n\n' + transcriptText() + '\n';
    var blob = new Blob([text], { type: 'text/plain' });
    var a = el('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'product-assistant-' + (cfg.partNumber || 'transcript').replace(/[^\w.-]+/g, '-') + '.txt';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 0);
  }

  function showListing() {
    close();
    var target = document.querySelector('.product-single, [data-section-type="product"], main');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ------------------------------------------------------------------ rendering

  function render() {
    log.textContent = '';
    log.appendChild(renderWelcome());

    state.turns.forEach(function (turn, i) {
      if (i === 0 && state.restoredCount) log.appendChild(el('p', 'pa-divider', t('earlier')));
      if (turn.role === 'user') {
        log.appendChild(renderUser(turn.text));
      } else {
        var isLast = i === state.turns.length - 1;
        log.appendChild(renderAnswer(turn.data || { answer: turn.text, answer_type: 'fact', source: 'datasheet' }, isLast));
      }
      if (state.restoredCount && i === state.restoredCount - 1) {
        var wrap = el('div', 'pa-center');
        wrap.appendChild(button(t('new_conversation'), 'pa-btn', newConversation, 'plus', 13));
        log.appendChild(wrap);
      }
    });
    scrollToEnd();
  }

  function renderWelcome() {
    var msg = el('div', 'pa-msg');
    var welcome = cfg.hasDatasheet ? 'welcome' : cfg.datasheetLinked ? 'welcome_unindexed' : 'welcome_no_datasheet';
    msg.appendChild(el('p', null, t(welcome)));

    // A datasheet linked on the page that the assistant can't read is already one click away
    if (!cfg.hasDatasheet && !cfg.datasheetLinked) {
      var actions = el('div', 'pa-actions');
      actions.appendChild(button(t('request_datasheet'), 'pa-btn', function () {
        openMail('datasheet_subject', '');
      }));
      msg.appendChild(actions);
    }

    if (!state.turns.length && cfg.starters && cfg.starters.length) {
      msg.appendChild(el('p', 'pa-label', t('start_with')));
      var list = el('div', 'pa-suggest');
      cfg.starters.forEach(function (q) {
        var b = el('button', 'pa-suggest__item');
        b.type = 'button';
        b.appendChild(el('span', null, q));
        b.appendChild(icon('arrow-right', 14));
        b.addEventListener('click', function () { ask(q); });
        list.appendChild(b);
      });
      msg.appendChild(list);
    }
    return msg;
  }

  function renderUser(text) {
    var wrap = el('div', 'pa-user');
    wrap.appendChild(el('p', 'pa-user__bubble', text));
    return wrap;
  }

  var BADGES = {
    datasheet: ['badge_datasheet', 'doc-source', ''],
    datasheet_listing: ['badge_datasheet_listing', 'doc-source', ''],
    listing: ['badge_listing', 'doc-source', ''],
    listing_live: ['badge_listing_live', 'cart-badge', ''],
    general: ['badge_general', 'warning', ' pa-badge--amber']
  };

  function renderBadge(data) {
    var spec;
    if (data.answer_type === 'not_found') spec = ['badge_not_found', 'warning', ' pa-badge--amber'];
    else if (data.answer_type === 'off_topic') spec = ['badge_off_topic', 'off-topic', ' pa-badge--muted'];
    else spec = BADGES[data.source] || BADGES.datasheet;
    var badge = el('p', 'pa-badge' + spec[2]);
    badge.appendChild(icon(spec[1], 12));
    badge.appendChild(el('span', null, t(spec[0])));
    return badge;
  }

  function renderAnswer(data, isLast) {
    var msg = el('div', 'pa-msg');
    msg.setAttribute('data-answer', '');
    var type = data.answer_type;

    msg.appendChild(renderBadge(data));

    // Safety: the caution always comes first and is never collapsed
    if (data.caution) {
      var danger = el('div', 'pa-callout pa-callout--danger');
      danger.appendChild(icon('alert', 14));
      danger.appendChild(el('p', null, data.caution));
      msg.appendChild(danger);
    }

    if (type === 'yes_no' && data.verdict_text) {
      var verdict = el('p', 'pa-verdict');
      var mark = el('span', 'pa-verdict__icon pa-verdict__icon--' + (data.verdict || 'depends'));
      mark.appendChild(icon(data.verdict === 'no' ? 'verdict-no' : data.verdict === 'yes' ? 'check' : 'warning', data.verdict === 'no' ? 9 : 12));
      verdict.appendChild(mark);
      verdict.appendChild(el('span', null, data.verdict_text));
      msg.appendChild(verdict);
    }

    if (data.lead) msg.appendChild(el('p', null, data.lead));

    if (type === 'commercial') {
      msg.appendChild(renderListing());
    }

    if (data.facts && data.facts.length) {
      var kv = el('div', 'pa-kv');
      data.facts.forEach(function (f) {
        var row = el('div', 'pa-kv__row');
        row.appendChild(el('span', 'pa-kv__label', f.label));
        row.appendChild(el('span', 'pa-kv__value', f.value));
        kv.appendChild(row);
      });
      msg.appendChild(kv);
    }

    if (data.steps && data.steps.length) {
      var steps = el('ol', 'pa-steps');
      data.steps.forEach(function (s, i) {
        var li = el('li', 'pa-step');
        li.appendChild(el('span', 'pa-step__num', String(i + 1)));
        li.appendChild(el('span', null, s));
        steps.appendChild(li);
      });
      msg.appendChild(steps);
    }

    if (data.table && data.table.columns && data.table.rows) {
      var table = el('div', 'pa-table');
      table.setAttribute('role', 'table');
      var head = el('div', 'pa-table__row pa-table__row--head');
      head.setAttribute('role', 'row');
      head.appendChild(el('span', null, ''));
      data.table.columns.forEach(function (c) {
        var h = el('span', null, c);
        h.setAttribute('role', 'columnheader');
        head.appendChild(h);
      });
      table.appendChild(head);
      data.table.rows.forEach(function (r) {
        var row = el('div', 'pa-table__row');
        row.setAttribute('role', 'row');
        var label = el('span', 'pa-table__label', r.label);
        label.setAttribute('role', 'rowheader');
        row.appendChild(label);
        (r.values || []).forEach(function (v) {
          var cell = el('span', null, v);
          cell.setAttribute('role', 'cell');
          row.appendChild(cell);
        });
        table.appendChild(row);
      });
      msg.appendChild(table);
    }

    if (data.closing) msg.appendChild(el('p', null, data.closing));

    var cites = (data.citations || []);
    if (cites.length) {
      if (type === 'not_found') msg.appendChild(el('p', 'pa-label', t('what_i_found')));
      var row = el('div', 'pa-cites');
      cites.forEach(function (c) { row.appendChild(renderCitation(c)); });
      msg.appendChild(row);
    }

    var actions = renderAnswerActions(data);
    if (actions) msg.appendChild(actions);

    if (data.stopped) msg.appendChild(el('p', 'pa-label', t('stopped')));

    var tools = el('div', 'pa-tools');
    var rating = el('div', 'pa-rating');
    var helpful = button(t('helpful'), 'pa-tool', function () { rate(msg, data, 'helpful', helpful, notHelpful); }, 'helpful', 12);
    var notHelpful = button(t('not_helpful'), 'pa-tool', function () { rate(msg, data, 'not_helpful', notHelpful, helpful); }, 'not-helpful', 12);
    helpful.setAttribute('aria-pressed', 'false');
    notHelpful.setAttribute('aria-pressed', 'false');
    rating.appendChild(helpful);
    rating.appendChild(notHelpful);
    tools.appendChild(rating);
    var copyBtn = button(t('copy'), 'pa-tool', function () {
      copyText(data.answer || '', copyBtn);
    }, 'copy', 12);
    tools.appendChild(copyBtn);
    msg.appendChild(tools);
    msg.paData = data;

    if (isLast && data.followups && data.followups.length) {
      var follow = el('div', 'pa-followups');
      data.followups.forEach(function (q) {
        follow.appendChild(button(q, 'pa-chip pa-chip--outline', function () { ask(q); }));
      });
      var holder = el('div');
      holder.appendChild(msg);
      holder.appendChild(follow);
      holder.style.display = 'contents';
      return holder;
    }
    return msg;
  }

  function documentUrl(name) {
    var match = (cfg.documents || []).filter(function (d) { return d.name === name; })[0];
    return match ? match.url : '';
  }

  function renderCitation(c) {
    var label;
    if (c.kind === 'listing') {
      label = t('listing_citation');
      return button(label, 'pa-chip pa-chip--cite', showListing, 'cite', 12);
    }
    label = c.document + (c.page ? ' · ' + t('page_short', { page: c.page }) : '');
    if (c.section) label = c.section + ' · ' + label;
    var a = el('a', 'pa-chip pa-chip--cite');
    a.href = c.url || '#';
    a.target = '_blank';
    a.rel = 'noopener';
    a.appendChild(icon('cite', 12));
    a.appendChild(el('span', null, label));
    if (c.snippet) attachPreview(a, c);
    return a;
  }

  // Citation preview (Figma 2747:324): hover after 300 ms or focus + Enter on desktop;
  // on touch the first tap shows the preview and its button opens the PDF
  function attachPreview(chip, c) {
    var timer = null;
    var pop = null;
    // Checked per interaction: the viewport can change after the chip is rendered
    function touch() { return window.matchMedia('(hover: none)').matches; }

    function build() {
      var box = el('div', 'pa-preview');
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-label', c.document);
      var total = docPages[documentUrl(c.document)];
      var head = el('p', 'pa-preview__title');
      head.appendChild(icon('file-14', 14));
      head.appendChild(el('span', null, c.page && total
        ? t('page_of', { document: c.document, page: c.page, total: total })
        : c.document + (c.page ? ' · ' + t('page_short', { page: c.page }) : '')));
      box.appendChild(head);
      var passage = el('div', 'pa-preview__passage');
      if (c.section) passage.appendChild(el('p', 'pa-label', c.section));
      passage.appendChild(el('p', 'pa-preview__highlight', c.snippet));
      box.appendChild(passage);
      if (c.url) {
        var open = el('a', 'pa-btn');
        open.href = c.url;
        open.target = '_blank';
        open.rel = 'noopener';
        open.appendChild(icon('open-13', 13));
        open.appendChild(el('span', null, c.page ? t('open_page', { page: c.page }) : c.document));
        box.appendChild(open);
      }
      var closeBtn = el('button', 'pa-preview__close');
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', t('cancel'));
      closeBtn.appendChild(icon('close', 12));
      closeBtn.addEventListener('click', hide);
      box.appendChild(closeBtn);
      return box;
    }

    function show() {
      if (pop) return;
      pop = build();
      pop.paClose = function () { hide(); chip.focus(); };
      chip.parentNode.insertBefore(pop, chip.nextSibling);
      var rect = chip.getBoundingClientRect();
      var logRect = log.getBoundingClientRect();
      pop.style.left = Math.max(0, rect.left - logRect.left) + 'px';
      pop.style.top = (rect.bottom - logRect.top + log.scrollTop + 6) + 'px';
      var popRect = pop.getBoundingClientRect();
      if (popRect.right > logRect.right - 16) {
        pop.style.left = Math.max(0, logRect.width - popRect.width - 24) + 'px';
      }
      // Flip above the chip when it would be clipped by the bottom of the log
      if (popRect.bottom > logRect.bottom - 8 && rect.top - logRect.top - popRect.height - 6 >= 0) {
        pop.style.top = (rect.top - logRect.top + log.scrollTop - popRect.height - 6) + 'px';
      }
      document.addEventListener('click', onDocClick, true);
    }

    function hide() {
      if (!pop) return;
      pop.remove();
      pop = null;
      document.removeEventListener('click', onDocClick, true);
    }
    function onDocClick(e) {
      if (pop && !pop.contains(e.target) && e.target !== chip && !chip.contains(e.target)) hide();
    }

    chip.addEventListener('mouseenter', function () {
      if (touch()) return;
      timer = setTimeout(show, 300);
    });
    chip.addEventListener('mouseleave', function () {
      clearTimeout(timer);
      // Keep the preview while the pointer moves into it
      setTimeout(function () { if (pop && !pop.matches(':hover')) hide(); }, 200);
    });
    chip.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !pop) { e.preventDefault(); show(); pop.querySelector('a, button').focus(); }
    });
    chip.addEventListener('click', function (e) {
      if (touch() && !pop) { e.preventDefault(); show(); }
    });
  }

  function renderAnswerActions(data) {
    var question = data.question || state.lastQuestion;
    var row = el('div', 'pa-actions');
    switch (data.answer_type) {
      case 'not_found':
        row.appendChild(button(t('ask_engineer'), 'pa-btn pa-btn--primary', function () { openMail('email_subject', question); }));
        row.appendChild(button(t('request_quote'), 'pa-btn', function () { openMail('quote_subject', question); }));
        break;
      case 'general':
        if (!cfg.hasDatasheet) {
          row.appendChild(button(t('request_datasheet'), 'pa-btn', function () { openMail('datasheet_subject', question); }));
        }
        row.appendChild(button(t('ask_engineer'), 'pa-btn', function () { openMail('email_subject', question); }));
        break;
      case 'safety':
        row.appendChild(button(t('ask_engineer'), 'pa-btn pa-btn--primary', function () { openMail('email_subject', question); }));
        break;
      case 'off_topic':
        row.appendChild(button(t('talk_to_engineering'), 'pa-chip pa-chip--outline', function () { openMail('email_subject', question); }));
        break;
      case 'commercial':
        var cart = pageButton('add');
        var quote = pageButton('quote-add') || pageButton('request-quote');
        if (cart && !cart.disabled) {
          row.appendChild(button(t('add_to_cart'), 'pa-btn pa-btn--primary', function () { close(); cart.click(); }, 'cart', 14));
        }
        if (quote) {
          row.appendChild(button(t('add_to_quote'), 'pa-btn', function () { close(); quote.click(); }));
        }
        break;
      default:
        return null;
    }
    return row.children.length ? row : null;
  }

  function pageButton(name) {
    return document.querySelector('form[action*="/cart/add"] button[name="' + name + '"]') ||
      document.querySelector('body.template-product form button[name="' + name + '"]');
  }

  // Stock, price and shipping come from the page's own product data, never from the model
  function currentVariant() {
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = idInput ? Number(idInput.value) : null;
    var variants = cfg.variants || [];
    return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
  }

  function renderListing() {
    var v = currentVariant();
    var kv = el('div', 'pa-kv');
    function row(label, value) {
      var r = el('div', 'pa-kv__row');
      r.appendChild(el('span', 'pa-kv__label', label));
      r.appendChild(el('span', 'pa-kv__value', value));
      kv.appendChild(r);
    }
    if (!v) {
      kv.appendChild(el('p', 'pa-kv__row', t('listing_missing')));
      return kv;
    }
    var stock = v.available
      ? (v.quantity > 0 ? t('in_stock', { count: v.quantity }) : '')
      : t('out_of_stock');
    row(t('condition'), [v.condition, stock].filter(Boolean).join(' · '));
    row(t('price'), v.price);
    if (v.available) row(t('shipping'), t('shipping_value'));
    (cfg.variants || []).forEach(function (other) {
      if (other.id !== v.id && other.condition && other.condition !== v.condition) {
        row(other.condition, other.available ? other.price : t('out_of_stock'));
      }
    });
    return kv;
  }

  // Helpful / Not helpful (Figma 2747:298): Helpful logs at once; Not helpful asks one question first
  function rate(msg, data, value, pressed, other) {
    if (msg.paRated === value) return;      // one record per rating per answer
    msg.paRated = value;
    pressed.setAttribute('aria-pressed', 'true');
    pressed.classList.add('is-selected');
    other.setAttribute('aria-pressed', 'false');
    other.classList.remove('is-selected');
    var existing = msg.querySelector('.pa-reasons, .pa-thanks');
    if (existing) existing.remove();
    if (value === 'helpful') {
      postFeedback({ kind: 'feedback', rating: 'helpful' }, data);
      msg.appendChild(renderThanks(t('thanks')));
      return;
    }
    msg.appendChild(renderReasons(msg, data, 'feedback'));
  }

  var REASONS = ['wrong_value', 'missing_detail', 'wrong_document', 'hard_to_read', 'other'];

  function renderReasons(msg, data, kind) {
    var box = el('div', 'pa-reasons');
    box.setAttribute('role', 'group');
    box.appendChild(el('p', 'pa-reasons__title', t('what_was_wrong')));
    var chips = el('div', 'pa-chips');
    REASONS.forEach(function (reason) {
      chips.appendChild(button(t('reason_' + reason), 'pa-chip pa-chip--outline', function () {
        postFeedback({ kind: kind, rating: 'not_helpful', reason: reason }, data);
        box.replaceWith(renderThanks(kind === 'report' ? t('thanks_report') : t('thanks')));
      }));
    });
    box.appendChild(chips);
    return box;
  }

  function renderThanks(text) {
    var box = el('div', 'pa-thanks');
    box.setAttribute('role', 'status');
    box.appendChild(icon('check', 12));
    box.appendChild(el('p', null, text));
    return box;
  }

  function postFeedback(fields, data) {
    var body = {
      session_id: sessionId(),
      product_id: cfg.productId || cfg.partNumber,
      product_title: cfg.productTitle,
      page_url: cfg.productUrl,
      question: (data.question || state.lastQuestion || '').slice(0, 500),
      answer: (data.answer || '').slice(0, 8000),
      answer_type: data.answer_type,
      source: data.source,
      citations: (data.citations || []).map(function (c) {
        return { document: c.document, page: c.page, url: c.url, section: c.section, kind: c.kind || 'document' };
      })
    };
    Object.keys(fields).forEach(function (k) { body[k] = fields[k]; });
    fetch(API + '/api/feedback', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    }).catch(function () {});
  }

  // Header menu "Report a problem": opens the reason picker on the last answer
  function reportProblem() {
    var answers = log.querySelectorAll('.pa-msg[data-answer]');
    var last = answers[answers.length - 1];
    if (!last || !last.paData) return;
    var existing = last.querySelector('.pa-reasons, .pa-thanks');
    if (existing) existing.remove();
    var picker = renderReasons(last, last.paData, 'report');
    last.appendChild(picker);
    last.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    var first = picker.querySelector('button');
    if (first) first.focus();
  }

  function copyText(text, btn) {
    var done = function () {
      var label = btn.querySelector('span');
      label.textContent = t('copied');
      setTimeout(function () { label.textContent = t('copy'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () {});
      return;
    }
    var ta = el('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { if (document.execCommand('copy')) done(); } catch (e) { /* no clipboard available */ }
    ta.remove();
  }

  // ------------------------------------------------------------------ working / error states

  function renderWorking() {
    var msg = el('div', 'pa-msg');
    msg.setAttribute('role', 'status');
    var line = el('div', 'pa-working');
    var dots = el('span', 'pa-dots');
    dots.setAttribute('aria-hidden', 'true');
    dots.appendChild(el('span'));
    dots.appendChild(el('span'));
    dots.appendChild(el('span'));
    line.appendChild(dots);
    var doc = cfg.documents && cfg.documents[0];
    var label = el('span', null, doc ? t('reading', { document: doc.name }) : t('reading_listing'));
    line.appendChild(label);
    msg.appendChild(line);

    var cycle = null;
    msg.reading = function (document, pages) {
      var total = document && docPages[documentUrl(document)];
      if (!pages.length || !total) {
        label.textContent = t('reading', { document: document || (doc ? doc.name : '') });
        return;
      }
      var i = 0;
      function tick() {
        label.textContent = t('reading_page', { document: document, page: pages[i % pages.length], total: total });
        i++;
      }
      tick();
      cycle = setInterval(tick, 700);
    };
    var cleanup = msg.remove.bind(msg);
    msg.remove = function () { if (cycle) clearInterval(cycle); cleanup(); };

    msg.slow = function () {
      if (cycle) clearInterval(cycle);
      label.textContent = t('slow_title');
      msg.appendChild(el('p', 'pa-working__body', t('slow_body')));
      var actions = el('div', 'pa-actions');
      actions.appendChild(button(t('email_question'), 'pa-btn', function () { openMail('email_subject', state.lastQuestion); }));
      actions.appendChild(button(t('cancel'), 'pa-btn', function () {
        if (state.controller) state.controller.abort('cancel');
      }));
      msg.appendChild(actions);
      scrollToEnd();
    };
    return msg;
  }

  function renderError(kind, info) {
    var msg = el('div', 'pa-msg ' + (kind === 'rate' ? 'pa-msg--rate' : 'pa-msg--error'));
    var alert = el('div', 'pa-alert');
    alert.setAttribute('role', 'alert');
    alert.appendChild(icon(kind === 'rate' ? 'warning-14' : 'alert', 14));
    var text;
    if (kind === 'rate') text = t('error_rate', { seconds: info.seconds });
    else if (kind === 'server') text = info.reference ? t('error_server', { reference: info.reference }) : t('error_server_noref');
    else text = t('error_connect');
    alert.appendChild(el('p', null, text));
    msg.appendChild(alert);

    if (kind !== 'rate') {
      var actions = el('div', 'pa-actions');
      actions.appendChild(button(t('try_again'), 'pa-btn pa-btn--primary', function () {
        msg.remove();
        var q = textarea.value.trim() || state.lastQuestion;
        if (q) send(q, true);
      }, 'retry', 14));
      actions.appendChild(button(t('email_sales'), 'pa-btn', function () { openMail('email_subject', state.lastQuestion); }));
      msg.appendChild(actions);
    }
    return msg;
  }

  // ------------------------------------------------------------------ asking

  function ask(question) {
    question = (question || '').trim();
    if (!question || state.busy || question.length > MAX_CHARS || Date.now() < state.rateUntil) return;
    if (root.hidden) {
      open(null, question);
      return;
    }
    // Starter chips disappear once the conversation starts
    var suggest = log.querySelector('.pa-suggest');
    if (suggest) {
      var label = suggest.previousElementSibling;
      suggest.remove();
      if (label && label.classList.contains('pa-label')) label.remove();
    }
    // Follow-up chips belong to the previous answer only
    log.querySelectorAll('.pa-followups').forEach(function (n) { n.remove(); });

    textarea.value = question;
    send(question, false);
  }

  function requestBody(question) {
    var history = state.turns.slice(-HISTORY_TURNS * 2).map(function (turn) {
      return { role: turn.role, text: (turn.text || '').slice(0, 4000) };
    });
    return JSON.stringify({
      query: question,
      session_id: sessionId(),
      product_id: cfg.productId,
      product_title: cfg.productTitle,
      product_description: cfg.productDescription,
      product_vendor: cfg.productVendor,
      product_type: cfg.productType,
      product_tags: cfg.productTags,
      product_price: cfg.productPrice,
      has_datasheet: cfg.hasDatasheet,
      documents: cfg.documents,
      history: history
    });
  }

  // Read a text/event-stream body, calling onEvent(name, data) per event
  function readSSE(response, onEvent) {
    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';
    function dispatch(block) {
      var name = 'message';
      var data = '';
      block.split('\n').forEach(function (line) {
        if (line.indexOf('event:') === 0) name = line.slice(6).trim();
        else if (line.indexOf('data:') === 0) data += line.slice(5).trim();
      });
      if (!data) return;
      var parsed;
      try { parsed = JSON.parse(data); } catch (e) { return; }
      onEvent(name, parsed);
    }
    return reader.read().then(function step(result) {
      if (result.done) {
        if (buffer.trim()) dispatch(buffer);
        return;
      }
      buffer += decoder.decode(result.value, { stream: true });
      var parts = buffer.split('\n\n');
      buffer = parts.pop();
      parts.forEach(dispatch);
      return reader.read().then(step);
    });
  }

  function send(question, isRetry) {
    state.busy = true;
    state.lastQuestion = question;
    updateComposer();

    if (!isRetry) {
      log.appendChild(renderUser(question));
    }
    var working = renderWorking();
    log.appendChild(working);
    scrollToEnd();

    var controller = new AbortController();
    state.controller = controller;
    var slowTimer = setTimeout(function () { if (!streaming) working.slow(); }, SLOW_AFTER_MS);
    var timeout = setTimeout(function () { if (!streaming) controller.abort('timeout'); }, TIMEOUT_MS);

    var streaming = null;       // the partial answer element once text starts arriving
    var partialText = '';
    var finished = false;

    function finish(result) {
      finished = true;
      result.question = question;
      state.turns.push({ role: 'user', text: question, at: Date.now() });
      state.turns.push({ role: 'assistant', text: result.answer, data: slim(result), at: Date.now() });
      save();
      if (textarea.value.trim() === question) textarea.value = '';
      var answer = renderAnswer(result, true);
      if (streaming && streaming.parentNode) streaming.replaceWith(answer); else log.appendChild(answer);
      streaming = null;
    }

    function fail(kind, info) {
      finished = true;
      if (streaming) streaming.remove();
      log.appendChild(renderError(kind, info || {}));
    }

    function onEvent(name, data) {
      if (name === 'status') {
        working.reading(data.document, data.pages || []);
      } else if (name === 'delta') {
        if (!streaming) {
          working.remove();
          streaming = renderStreaming(data);
          log.appendChild(streaming);
        }
        partialText += data.text || '';
        streaming.setText(partialText);
        scrollToEnd();
      } else if (name === 'restart') {
        // The server lost its first model mid-answer and is starting over on another route
        partialText = '';
        if (streaming) { streaming.remove(); streaming = null; }
        log.appendChild(working);
        scrollToEnd();
      } else if (name === 'done') {
        working.remove();
        finish(data);
      } else if (name === 'error') {
        working.remove();
        fail(data.code === 'timeout' ? 'server' : 'server', data);
      }
    }

    fetch(API + '/api/query/stream', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'text/event-stream' },
      signal: controller.signal,
      body: requestBody(question)
    })
      .then(function (res) {
        var type = res.headers.get('Content-Type') || '';
        if (res.status === 200 && type.indexOf('text/event-stream') === 0 && res.body) {
          return readSSE(res, onEvent).then(function () {
            if (!finished) fail('server', {});
          });
        }
        // Not a stream: a JSON error (429, 403, 5xx) or a proxy that buffered the body
        return res.json().catch(function () { return {}; }).then(function (body) {
          working.remove();
          if (res.status === 200 && body.answer_type) {
            finish(body);
          } else if (res.status === 429) {
            var seconds = Number(body.retry_after || res.headers.get('Retry-After')) || 30;
            finished = true;
            log.appendChild(renderError('rate', { seconds: seconds }));
            startCountdown(seconds);
          } else {
            fail('server', { reference: body && body.reference });
          }
        });
      })
      .catch(function () {
        working.remove();
        var reason = controller.signal.reason;
        if (reason === 'cancel') return;            // user cancelled: question stays in the box
        if (reason === 'stop') {
          // Stopped: keep what arrived (if anything), mark it, offer to regenerate
          finished = true;
          if (!streaming) {
            streaming = renderStreaming({});
            streaming.setText('');
            log.appendChild(streaming);
          }
          streaming.stop(question);
          return;
        }
        if (!finished) fail(reason === 'timeout' ? 'server' : 'connect', {});
      })
      .then(function () {
        clearTimeout(slowTimer);
        clearTimeout(timeout);
        state.busy = false;
        state.controller = null;
        updateComposer();
        scrollToEnd();
      });
  }

  // Partial answer while the lead is still arriving (Figma 2746:183 "Streaming")
  function renderStreaming(data) {
    var msg = el('div', 'pa-msg pa-msg--streaming');
    var badge = renderBadge({ answer_type: 'fact', source: cfg.hasDatasheet ? 'datasheet' : 'listing' });
    msg.appendChild(badge);
    var p = el('p');
    var text = el('span');
    var caret = el('span', 'pa-caret');
    caret.setAttribute('aria-hidden', 'true');
    p.appendChild(text);
    p.appendChild(caret);
    msg.appendChild(p);
    msg.setText = function (value) { text.textContent = value; };
    msg.stop = function (question) {
      caret.remove();
      msg.classList.remove('pa-msg--streaming');
      msg.appendChild(el('p', 'pa-label', t('stopped')));
      var row = el('div', 'pa-followups');
      row.appendChild(button(t('stopped_regenerate'), 'pa-chip pa-chip--outline', function () {
        msg.remove();
        row.remove();
        send(question, true);
      }, 'retry', 12));
      log.appendChild(row);
    };
    return msg;
  }

  // Keep stored answers small: drop snippets, keep what rendering needs
  function slim(data) {
    var copy = JSON.parse(JSON.stringify(data));
    delete copy.metadata;
    (copy.citations || []).forEach(function (c) { if (c.snippet) c.snippet = c.snippet.slice(0, 400); });
    return copy;
  }

  function sessionId() {
    try {
      var id = sessionStorage.getItem('pa:session');
      if (!id) {
        id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
        sessionStorage.setItem('pa:session', id);
      }
      return id;
    } catch (e) {
      return null;
    }
  }

  function startCountdown(seconds) {
    state.rateUntil = Date.now() + seconds * 1000;
    var tick = function () {
      var left = Math.ceil((state.rateUntil - Date.now()) / 1000);
      if (left <= 0) {
        countdownEl.hidden = true;
        state.rateUntil = 0;
        updateComposer();
        return;
      }
      countdownEl.hidden = false;
      countdownEl.textContent = t('retry_in', { seconds: left });
      updateComposer();
      setTimeout(tick, 1000);
    };
    tick();
  }

  // ------------------------------------------------------------------ composer

  function autoGrow() {
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 88) + 'px';
  }

  function updateComposer() {
    var len = textarea.value.length;
    var trimmed = textarea.value.trim();
    var over = len > MAX_CHARS;
    var active = document.activeElement === textarea && len > 0;

    inputBox.classList.toggle('is-active', active || over);
    inputBox.classList.toggle('is-over', over);
    helper.hidden = !(active || over);
    helperText.textContent = over ? t('over_limit') : t('hint');
    counter.hidden = len < COUNTER_FROM;
    counter.textContent = len + ' / ' + MAX_CHARS;
    textarea.setAttribute('aria-invalid', over ? 'true' : 'false');

    sendBtn.disabled = !trimmed || over || state.busy || Date.now() < state.rateUntil;
    sendBtn.hidden = state.busy;
    stopBtn.hidden = !state.busy;
    autoGrow();
  }

  stopBtn.addEventListener('click', function () {
    if (state.controller) state.controller.abort('stop');
  });

  textarea.addEventListener('input', updateComposer);
  textarea.addEventListener('focus', function () { root.classList.add('is-typing'); updateComposer(); });
  textarea.addEventListener('blur', function () { root.classList.remove('is-typing'); updateComposer(); });
  textarea.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
      e.preventDefault();
      if (!sendBtn.disabled) ask(textarea.value);
    }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!sendBtn.disabled) ask(textarea.value);
  });

  // ------------------------------------------------------------------ entry points

  var entryForm = document.querySelector('[data-pa-entry-form]');
  if (entryForm) {
    entryForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = entryForm.querySelector('input');
      var q = input.value.trim();
      open(entryForm.querySelector('button'), q || null);
      input.value = '';
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-pa-ask]');
    if (chip && !root.contains(chip)) {
      open(chip, chip.getAttribute('data-pa-ask'));
      return;
    }
    var launcher = e.target.closest('[data-pa-open]');
    if (launcher) {
      e.preventDefault();
      open(launcher, null);
    }
  });

  // ------------------------------------------------------------------ document page counts

  if (cfg.documents && cfg.documents.length) {
    var first = cfg.documents[0];
    fetch(API + '/api/documents?url=' + encodeURIComponent(first.url))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (info) {
        if (!info || !info.pages) return;
        docPages[first.url] = info.pages;
        var pages = t('pages', { count: info.pages });
        var chip = root.querySelector('[data-pa-source-pages]');
        if (chip) chip.textContent = ' · ' + pages;
        var row = document.querySelector('[data-pa-doc][data-url="' + CSS.escape(first.url) + '"] [data-pa-pages]');
        if (row) {
          row.textContent = ' · ' + pages;
          row.hidden = false;
        }
      })
      .catch(function () {});
  }

  // ------------------------------------------------------------------ product-specific starter questions

  function loadSuggestions() {
    if (!cfg.productId) return;
    var params = new URLSearchParams({
      product_id: cfg.productId, title: cfg.productTitle || '', vendor: cfg.productVendor || '', type: cfg.productType || ''
    });
    fetch(API + '/api/suggestions?' + params.toString())
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var questions = data && data.questions ? data.questions.slice(0, 3) : [];
        if (questions.length < 3) return;
        cfg.starters = questions;
        var chips = document.querySelectorAll('[data-pa-card] .pa-chips [data-pa-ask]');
        chips.forEach(function (chip, i) {
          if (questions[i]) {
            chip.textContent = questions[i];
            chip.setAttribute('data-pa-ask', questions[i]);
          }
        });
        if (!root.hidden && !state.turns.length) render();
      })
      .catch(function () {});
  }
  // Fetched on the first sign of a person (a scroll, touch, pointer or key), not on page load: crawlers
  // render every product page and each uncached fetch costs a vector search and a model call
  var suggestionsRequested = false;
  function requestSuggestions() {
    if (suggestionsRequested) return;
    suggestionsRequested = true;
    loadSuggestions();
  }
  ['scroll', 'pointerdown', 'pointermove', 'touchstart', 'keydown'].forEach(function (type) {
    window.addEventListener(type, requestSuggestions, { once: true, passive: true });
  });

  window.productAssistant = { open: function (question) { open(null, question); }, close: close };
})();
